import { ArrowLeft, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

export default function CmsEditBar({ editMode, pageTitle }) {
  if (!editMode) return null;

  return (
    <div className="sticky top-0 z-40 border-b border-blue-100 bg-white px-4 py-3 shadow-sm">
      <div className="container flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-[#4391d1] text-white">
            <ShieldCheck className="h-4 w-4" />
          </span>
          <div>
            <p className="m-0 text-xs font-black uppercase tracking-widest text-[#1278b5]">Secure CMS Edit Mode</p>
            <p className="m-0 text-sm font-bold text-gray-700">{pageTitle}</p>
          </div>
        </div>
        <Link
          className="inline-flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-black text-gray-700 hover:border-[#4391d1] hover:text-[#1278b5]"
          to="/dashboard/cms"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to CMS
        </Link>
      </div>
    </div>
  );
}
